import { jsx as _jsx } from "react/jsx-runtime";
import { SocialsAiInstructionsItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = ({ isSaveLoading, onCancel, onSave }) => (_jsx(SocialsAiInstructionsItem, { isAdd: true, isSaveLoading: isSaveLoading, onCancel: onCancel, onSave: onSave }));
export default Add;
